import React, { memo, useEffect, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { actionUrl, isMaster, isProd, isQA } from './InquireNowForm.utils'
import { FormContent, FormInput, useFormState } from '../Form/Form'
import InquireNowFormValidation from './InquireNowFormValidation'
import './InquireNowForm.scss'
import HiddenFields from './component/HiddenFields'

const InquireNowForm = ({ propertyName }: { propertyName: string }) => {
  const isDev = process.env.NODE_ENV === 'development'
  const [isRecaptchaChecked, setIsRecaptchaChecked] = useState<boolean>(false)
  const [isAgreeChecked, setIsAgreeChecked] = useState<boolean>(false)
  const [isCorrectValues, setIsCorrectValues] = useState<boolean>(false)

  const { values, errors, onFieldValueChange, onFieldBlur } = useFormState({
    validation: InquireNowFormValidation,
  })

  useEffect(() => {
    const hasErrors = Object.values(errors).some((value) => value !== '')
    const hasAnyValue = Object.values(values).some((value) => value !== '')

    if (!hasErrors && hasAnyValue) {
      setIsCorrectValues(true)
    }
  }, [onFieldValueChange])

  return (
    <form action={actionUrl?.url} method="POST" className="inquire-now-form">
      <HiddenFields propertyName={propertyName} />

      <FormInput
        id="first_name"
        name="first_name"
        placeholder="First Name"
        onChange={onFieldValueChange}
        onBlur={onFieldBlur}
        error={errors.first_name}
        half
      />

      <FormInput
        id="last_name"
        name="last_name"
        placeholder="Last Name"
        onChange={onFieldValueChange}
        onBlur={onFieldBlur}
        error={errors.last_name}
        half
      />

      <FormInput
        type="email"
        id="email"
        name="email"
        placeholder="Email"
        onChange={onFieldValueChange}
        onBlur={onFieldBlur}
        error={errors.email}
        half
      />

      <FormInput
        id="mobile"
        name="mobile"
        placeholder="Mobile"
        onChange={onFieldValueChange}
        onBlur={onFieldBlur}
        error={errors.mobile}
        half
      />

      <FormInput
        id="city"
        name="city"
        placeholder="City"
        onChange={onFieldValueChange}
        onBlur={onFieldBlur}
        error={errors.city}
        half
      />

      <FormContent>
        <div className="inquire-now-form__terms">
          <div className="inquire-now-form__terms--privacy-notice">
            <label htmlFor="i-agree">
              <input
                id="i-agree"
                type="checkbox"
                checked={isAgreeChecked}
                readOnly
              />
              <span
                role="checkbox"
                onClick={(event): void => {
                  event.currentTarget.blur()
                  setIsAgreeChecked(!isAgreeChecked)
                }}
                onKeyPress={(event): void => {
                  if (event.which === 13) {
                    setIsAgreeChecked(!isAgreeChecked)
                  }
                }}
                tabIndex={0}
                aria-checked={isAgreeChecked}
                aria-labelledby="i-agree"
                data-testid="inquire-now-i-agree"
              />
            </label>
            <div className="inquire-now-form__terms--privacy-notice-text">
              I understand and agree with the{' '}
              <a href="/privacy-notice/" target="_blank">
                Privacy Notice
              </a>{' '}
              and{' '}
              <a href="/terms-and-conditions/" target="_blank">
                Terms & Conditions
              </a>
            </div>
          </div>

          {isDev ? null : (
            <ReCAPTCHA
              sitekey={process.env.GATSBY_RECAPTCHA_API_KEY || ''}
              onChange={(value: string | null): void => {
                setIsRecaptchaChecked(!!value)
              }}
            />
          )}

          <input
            type="submit"
            className="inquire-now-form__terms--btn"
            // disabled={!isRecaptchaChecked && !isAgreeChecked}
            disabled={
              !(isAgreeChecked && isCorrectValues && isDev
                ? true
                : isRecaptchaChecked)
            }
            value="Submit"
          />
        </div>
      </FormContent>
    </form>
  )
}

export default memo(InquireNowForm)
